import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'emptyValue'
})
export class EmptyValuePipe implements PipeTransform {
    transform(value: any, allowZero = false): any {
        if (
            (!value || value === '')
            && !(allowZero && value === 0)
        ) {
            return '-';
        }
        return value;
    }

}
